"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { MapSEOTagsReturnType } from "@shared/lib";
import { STAND } from "@shared/utils";
import Head from "next/head";

type Props = MapSEOTagsReturnType;

export const PageHead = ({ canonicalURL, keywords, metaDescription, metaRobots, metaImage, metaTitle, metaViewport }: Props) => {
  const clientConfig = useClientConfig();

  const SEOCanonicalURL = canonicalURL ? <link rel="canonical" href={canonicalURL} /> : null;

  const SEOKeywords = keywords ? <meta name="keywords" content={keywords} /> : null;

  const SEODescription = metaDescription ? <meta name="description" content={metaDescription} /> : null;

  const SEOImageOpenGraph = <meta property="og:image" content={metaImage} />;

  const SEOViewport = <meta name="viewport" content={metaViewport || "width=device-width, initial-scale=1"} />;

  const getSEORobots = () => {
    if (clientConfig?.config?.stand === STAND.DEV) {
      return <meta name="robots" content="noindex,nofollow" />;
    }

    return metaRobots ? <meta name="robots" content={metaRobots} /> : null;
  };

  const SEOTags = (
    <>
      {SEOKeywords}
      {SEODescription}
      {SEOCanonicalURL}
      {SEOImageOpenGraph}
      {SEOViewport}

      {getSEORobots()}
    </>
  );

  return (
    <Head>
      <title>{metaTitle}</title>
      <meta charSet="UTF-8" />
      <link rel="icon" href={clientConfig?.config?.faviconUrl} />
      <meta name="theme-color" content="#ffffff" />
      <meta name="color-scheme" content="only light" />
      {SEOTags}
    </Head>
  );
};
